
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.78 15.01c5.66-.06 11.31.34 16.91 1.18 1.51.27 2.72 1.41 3.1 2.89.69 3.56 1.05 7.18 1.07 10.81-.1 3.7-.46 7.38-1.07 11.02-.32 2.03-2.46 2.67-3.1 2.89-5.52.9-11.11 1.33-16.7 1.28-6.42 0-12.95-.43-16.7-1.28a3.927 3.927 0 01-3.1-2.89c-.87-3.57-1.26-7.24-1.18-10.92-.04-3.62.24-7.24.86-10.81.32-2.04 2.57-2.68 3.1-2.89 5.55-.93 11.18-1.36 16.81-1.28v0z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M24.91 22.58v14.84L37.9 30l-12.99-7.42z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    